import createTaskModule from '../utils/createTaskModule';

export const appStoreModalStore = createTaskModule();
